import { SkipBack, SkipForward } from 'lucide-react';
import './SkipButton.css';

type Props = {
    direction: 'back' | 'forward';
    onClick: () => void;
};

export function SkipButton({ direction, onClick }: Props) {
    return (
        <button className="skipButton" onClick={onClick} aria-label={direction === 'back' ? 'Previous track' : 'Next track'}>
            {direction === 'back' ? (
                <SkipBack size={18} strokeWidth={2.75} />
            ) : (
                <SkipForward size={18} strokeWidth={2.75} />
            )}
        </button>
    );
}
